module.exports = __webpack_public_path__ + "frontend/img/icon_male.a61df213.svg";